import useSWR from "swr";
import useSWRMutation from "swr/mutation";
import { useAccountId } from "../../../../auth/useAccountId";
import { CHECKOUT_API_HOSTNAME } from "../../../../env";
import fulfill from "../../../../fulfill";
import type { ProfileConfiguration } from "../../../../types/checkout";

const fetchProfiles = async (key: string): Promise<ProfileConfiguration[]> => {
    const [accountId] = key.split("/");
    return await fulfill.get({
        accountId: accountId,
        url: `${CHECKOUT_API_HOSTNAME}/v1/admin/session/profiles?limit=100`,
        handlers: {
            200: (profiles) => profiles,
        },
    });
};

const fetchCreateProfile = async (
    _key: string,
    options: {
        arg: {
            accountId: string;
            profile: Partial<ProfileConfiguration>;
        };
    },
): Promise<{
    accountId: string;
    paymentProfile: ProfileConfiguration;
}> => {
    return await fulfill.post({
        accountId: options.arg.accountId,
        url: `${CHECKOUT_API_HOSTNAME}/v1/admin/session/profiles`,
        json: options.arg.profile,
        handlers: {
            200: (profile) => ({
                accountId: options.arg.accountId,
                paymentProfile: profile,
            }),
        },
    });
};

export const usePaymentProfiles = () => {
    const accountId = useAccountId();
    const key = `${accountId}/payment-profiles`;
    const { data, isLoading } = useSWR(
        () => (accountId ? key : null),
        fetchProfiles,
    );
    const {
        trigger: createProfile,
        isMutating: creatingProfile,
        error: createError,
        data: createdProfile,
    } = useSWRMutation(key, fetchCreateProfile);

    return {
        profiles: data || [],
        isLoading,
        createProfile,
        creatingProfile,
        createError,
        createdProfile,
        isCreated: !!createdProfile,
    };
};
